import { gql } from "@apollo/client";

// CRA-safe project outsourcing API contract shared by the website's local
// Chakra implementation and the business app's Tailwind implementation.
// Keep this file in the data package so GraphQL codegen can pluck these
// operations without either app compiling the other app's UI.
export const PROJECT_OUTSOURCING_SERVICE_TYPES = [
  "construction",
  "facility-maintenance",
  "renovations",
];

export const REQUEST_CONSTRUCTION_PROJECT = gql`
  mutation RequestConstructionProject(
    $constructionProjectRequestDto: ConstructionProjectRequestDto!
  ) {
    requestConstructionProject(
      constructionProjectRequestDto: $constructionProjectRequestDto
    )
  }
`;

export const REQUEST_FACILITY_MAINTENANCE = gql`
  mutation RequestFacilityMaintenance(
    $facilityMaintenanceRequestDto: FacilityMaintenanceRequestDto!
  ) {
    requestFacilityMaintenance(
      facilityMaintenanceRequestDto: $facilityMaintenanceRequestDto
    )
  }
`;

export const REQUEST_RENOVATION_PROJECT = gql`
  mutation RequestRenovationProject(
    $renovationProjectRequestDto: RenovationProjectRequestDto!
  ) {
    requestRenovationProject(
      renovationProjectRequestDto: $renovationProjectRequestDto
    )
  }
`;
